/**
 * The red button is Leave, for both roles, with no question first (decision
 * 54): it leaves this device at once. In a lesson the call stays open for the
 * other person and the lesson goes on (utils/callEnd); a call outside any
 * lesson has nothing to go on, so leaving ends it.
 */

export interface EndCallPlan {
  /** End the call for both as it is left (a call outside any lesson). */
  closeRoom: boolean;
}

export function endCallPlan(p: { booked: boolean }): EndCallPlan {
  return { closeRoom: !p.booked };
}

/**
 * What More holds in a lesson: Invite Someone (or Invite a Parent), once
 * guests by link are open (GUEST_JOIN); with nothing in it, there is no More.
 */
export function moreHasInvite(p: { guestJoin: boolean; booked: boolean }): boolean {
  return p.guestJoin && p.booked;
}
